<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('ProjectSettings|Custom Report Configuration') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'ProjectSettings|Project custom reports allow you to create predefined task reports for this project. These reports can be accessed by project members using the /project command in Direct Messages with the bot.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|How to Access') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|Once configured, project members can access the custom report at any time by sending the /project command in a Direct Message with the bot. The bot will generate and send a report based on the saved project configuration.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Configuration Options') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|You can configure the project custom report with various filters and options:'
                )
              }}
            </p>
            <ul style="margin: 0 0 16px 0; padding-left: 20px; color: #666">
              <li style="margin-bottom: 8px">
                {{
                  s__('ProjectSettings|Filter by task status (open, in progress, completed, etc.)')
                }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Filter by task type (category)') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Filter by project labels') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Group tasks by assignee, status, or other criteria') }}
              </li>
              <li style="margin-bottom: 8px">
                {{
                  s__('ProjectSettings|Sort tasks by various criteria (due date, priority, etc.)')
                }}
              </li>
            </ul>

            <h4>{{ s__('ProjectSettings|Project vs Personal Reports') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|Project custom reports are configured at the project level and are available to all project members. Personal custom reports (configured in your profile) are private to you and can include tasks from multiple projects.'
                )
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('ProjectSettings|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}

.info-section ul {
  line-height: 1.6;
}
</style>
